export default function widgetFlyout() {
    const iconInfo = document.getElementById('iconInfo');
    const iconClose = document.getElementById('iconClose');
    const infoBtn = document.getElementById('infoBtn');

    iconInfo.addEventListener('click', (e) => {
        let thisBtn = e.currentTarget;
        thisBtn.classList.add('hidden');
        iconClose.classList.remove('hidden');
        const flyout = document.getElementById('flyout');
        flyout.classList.toggle('translate-x-full');
        infoBtn.classList.remove('bg-black/60');
    });

    iconClose.addEventListener('click', (e) => {
        let thisBtn = e.currentTarget;
        thisBtn.classList.add('hidden');
        iconInfo.classList.remove('hidden');
        const flyout = document.getElementById('flyout');
        flyout.classList.toggle('translate-x-full');
        infoBtn.classList.add('bg-black/60');
    });
}
